import axios from 'axios';
const { REACT_APP_STUDIO_API } = process.env;


const studioApi = axios.create({
    baseURL: REACT_APP_STUDIO_API,
});

export default studioApi;
